import { Component, Input, OnInit } from '@angular/core';
import { FileStorageService, OrganisationSettingService, UserService } from '../../services';
import { IUser } from '../../interfaces/user';
import { FormBuilder, FormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { ReceiveSummaryEnum } from '../../enums/receive-summary.enum';
import { Message } from '../../classes/Message';
import { OrganisationSettingEnum } from '../../enums/organisation-settings';
import { IOrganisationSetting } from '../../interfaces/organisation-setting';

@Component({
  selector: 'app-booking-summary-settings',
  templateUrl: './booking-summary-settings.component.html',
  styleUrls: ['./booking-summary-settings.component.scss'],
})
export class BookingSummarySettingsComponent implements OnInit {
  private userList: IUser[] = [];
  private searchForm: FormGroup;
  private loading: boolean = false;
  files: any[] = [];
  parsedSettings: {} = {};
  private logoSetting: IOrganisationSetting;
  uploading: boolean;
  presignedURL: string;

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private fileStorageService: FileStorageService,
    private organisationSettingService: OrganisationSettingService,
  ) {}

  @Input() organisationId: number;
  expanded = false;

  async ngOnInit() {
    this.loadOrgSettings();
    this.initForm();
  }

  private loadOrgSettings() {
    this.organisationSettingService
      .search({ component: 'booking-summary-settings', organisationId: this.organisationId })
      .then((settings) => {
        this.parsedSettings = this.organisationSettingService.parseSettings(settings);
        this.logoSetting = this.parsedSettings[OrganisationSettingEnum.DailySummaryLogo];

        if (this.logoSetting != null) {
          this.setPresignedUrl(this.logoSetting.charValue);
        }
      });

    // Get a list of the users
    this.loading = true;

    this.userService
      .getUsersWithRoles({
        first: 0,
        rows: 99,
        filters: { organisationId: { value: this.organisationId } },
      })
      .then((users) => {
        this.userList = users.items;
        this.loading = false;
      });
  }

  private initForm() {
    this.searchForm = this.fb.group({
      firstName: [''],
      lastName: [''],
      email: [''],
    });
  }

  filteredUsers() {
    if (this.userList.length == 0) {
      return [];
    }

    let x = this.userList
      .filter((x) => x.isLockedOut == false)
      .filter(
        (x) =>
          this.searchForm.value.firstName == '' ||
          x.firstName.toLowerCase().includes(this.searchForm.value.firstName.toLowerCase()),
      )
      .filter(
        (x) =>
          this.searchForm.value.lastName == '' ||
          x.lastName.toLowerCase().includes(this.searchForm.value.lastName.toLowerCase()),
      )
      .filter(
        (x) =>
          this.searchForm.value.email == '' ||
          x.email.toLowerCase().includes(this.searchForm.value.email.toLowerCase()),
      );

    x.forEach((x) => {
      x.receiveDailySummary =
        ReceiveSummaryEnum.Daily === (x.receiveSummary & ReceiveSummaryEnum.Daily);

      x.receiveWeeklySummary =
        ReceiveSummaryEnum.Weekly === (x.receiveSummary & ReceiveSummaryEnum.Weekly);

      x.receiveMonthlySummary =
        ReceiveSummaryEnum.Monthly === (x.receiveSummary & ReceiveSummaryEnum.Monthly);
    });

    return x;
  }

  clear() {
    this.searchForm.reset({ firstName: '', lastName: '', email: '' });
    this.userList = [...this.userList]; // Force an update of the UI
  }

  updateSetting(x: IUser, summaryType: string, receiveUpdates: boolean) {
    console.log('SUMMARY TYPE ', summaryType);

    if (receiveUpdates) {
      x.receiveSummary |= ReceiveSummaryEnum[summaryType];
    } else {
      x.receiveSummary ^= ReceiveSummaryEnum[summaryType];
    }

    this.userService.updateReceiveSummary(x.id, x.receiveSummary);
  }

  onBeforeUpload(event: any) {
    this.uploading = true;
    event.formData.append('lastModifiedDate', this.files[0].LastModifiedDate.getTime());
    event.formData.append('size', '400');
  }

  onSelect(event) {
    this.files = [];
    if (event.files.length > 0) {
      for (let file of event.files) {
        var fileDetails = {
          LastModifiedDate: file.lastModifiedDate,
          Name: file.name,
          Size: file.size,
          Type: file.type,
        };
        this.files.push(fileDetails);
      }
    }
  }

  setPresignedUrl(x) {
    this.fileStorageService.getPreSignedURLs([x]).then((urls) => (this.presignedURL = urls[0]));
  }

  onFileUpload(event) {
    //const response = JSON.parse(event.xhr.response);
    const response = event.originalEvent.body;

    this.uploading = false;

    if (response.successfully) {
      this.setPresignedUrl(response.fileData.guid);

      if (this.logoSetting != null && this.logoSetting.charValue != '') {
        const patch = compare({}, { charValue: response.fileData.guid });
        this.organisationSettingService.patch(this.logoSetting.id, patch);
      } else {
        this.organisationSettingService
          .create({
            organisationId: this.organisationId,
            setting: OrganisationSettingEnum.DailySummaryLogo,
            charValue: response.fileData.guid,
          })
          .then((x) => {
            this.logoSetting = x;
          });
      }
      //this.logger.debug("UPLOAD 1");
      //this.customerdata.logo = response.fileData.url;
      //this.logger.debug("UPLOAD 2");
      //this.messageService.ShowSuccess('File Uploading', 'Logo uploaded.');
    } else {
      // error
      //this.messageService.ShowError('File Uploading', 'Impossible to add a new logo.');
    }
  }

  removeLogo() {
    this.organisationSettingService.delete(this.logoSetting.id).then(() => {
      this.logoSetting = null;
    });
  }
}
